import { Service } from './service';

export class PublicService extends Service {
  protected profiles:any;
  protected communities:any;
  protected unfurlCache:string[];

  constructor() {
    super();
    this.profiles = [];
    this.communities = [];
    this.unfurlCache = [];
  }

  public getProfile(id:string) {
    return this.profiles[id];
  }

  public async loadProfiles(ids:string[]) {
    let missing = [];
    for(let i = 0; i < ids.length; i++)
      if(!this.profiles[ids[i]])
        missing.push(ids[i]);

    if(missing.length == 0)
      return {success: true};

    let response = await this.sendCommand('public', 'get-profiles', {ids: missing});

    if(response.status != 200)
      return {success: false, message: response.body.message};

    let profiles = response.body.profiles;

    for(let i = 0; i < profiles.length; i++) 
      this.addProfileToCache(profiles[i]);

    return {success: true};
  }

  public async loadProfileFromSlug(slug:string) {
    if(this.profiles[slug])
      return {success: true, profile: this.profiles[slug]};

    let response = await this.sendCommand('public', 'get-profile', {slug});
    if(response.status != 200)
      return {success: false, message: response.body.message};

    let profile = response.body.profile;
    this.addProfileToCache(profile);

    return {success: true, profile};
  }

  public addProfileToCache(profile:any) {
    // if(profile.slug) {
    //   let i = profile.slug.indexOf('#');
    //   if(i != -1)
    //     profile.slug = profile.slug.substring(i+1);
    // }

    if(!profile.friends) profile.friends = [];
    if(!profile.following) profile.following = [];
    if(!profile.followers) profile.followers = [];

    this.profiles[profile.id] = profile;
    this.profiles[profile.slug] = profile;
  }

  public async unfurl(url:string) {
    if(this.unfurlCache[url])
      return {success: true, data: this.unfurlCache[url]};

    let response = await this.sendCommand('public', 'unfurl', {url});

    if(response.status != 200)
      return {success: false, message: response.body.message};

    this.unfurlCache[url] = response.body;

    return {success: true, data: response.body};
  }

  public unfurlFromCache(url:string) {
    return this.unfurlCache[url];
  }

  public async getTwitterEmbed(url:string) {
    let response = await this.sendCommand('public', 'get-twitter-embed', {url});

    if(response.status != 200)
      return {success: false, message: response.body.message};

    return {success: true, embed: response.body.embed};
  }

  // communities
  public getCommunity(id:string) {
    return this.communities[id];
  }
  
  public addCommunityToCache(community:any) {
    this.communities[community.id] = community;
    this.communities[community.slug] = community;
  }

  public async loadCommunities(ids:string[]) {
    let missing = [];
    for(let i = 0; i < ids.length; i++)
      if(!this.communities[ids[i]])
        missing.push(ids[i]);

    if(missing.length == 0)
      return {success: true};

    let response = await this.sendCommand('public', 'get-communities', {ids: missing});

    if(response.status != 200)
      return {success: false, message: response.body.message};

    let communities = response.body.communities;

    for(let i = 0; i < communities.length; i++) 
      this.addCommunityToCache(communities[i]);

    return {success: true};
  }

  public async loadCommunity(slug:string) {
    let response = await this.sendCommand('public', 'get-community', {slug});

    if(response.status != 200)
      return {success: false, message: response.body.message};

    this.addCommunityToCache(response.body.community);

    return {success: true, community: response.body.community};
  }

  public async findCommunities(params:any) {
    let response = await this.sendCommand('public', 'find-communities', params);

    if(response.status != 200)
      return {success: false, message: response.body.message};

    let communities = response.body.communities;

    for(let i = 0; i < communities.length; i++) 
      this.addCommunityToCache(communities[i]);

    return {success: true, communities};
  }

  public async getCommunityMembers() {
    let response = await this.sendCommand('public', 'get-community-members');
    if(response.status != 200)
      return {success: false, message: response.body.message};
    return {success: true, members: response.body.members};
  }

  public async getCommunityInviteCount(email:string) {
    let response = await this.sendCommand('public', 'get-community-invite-count', {email});
    if(response.status != 200)
      return {success: false, message: response.body.message};
    return {success: true, count: response.body.count};
  }

  public async getCommunityInvite(id:string) {
    let response = await this.sendCommand('public', 'get-community-invite', {id});
    if(response.status != 200)
      return {success: false, message: response.body.message};
    return {success: true, invite: response.body.invite};
  }

  public async declineCommunityInvite(params:any) {
    let response = await this.sendCommand('public', 'decline-community-invite', params);
    if(response.status != 200)
      return {success: false, message: response.body.message};
    return {success: true, invite: response.body.invite};
  }
}
